import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [_c("template", { slot: "actions" })],
        2
      ),
      _c(
        VCard,
        [
          _c(
            VCardText,
            [
              _c(
                VForm,
                { ref: "form_channel", attrs: { id: "form_channel" } },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("chatbots.channels.name")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                              rules: _vm.rules.name,
                            },
                            model: {
                              value: _vm.channel.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.channel, "name", $$v)
                              },
                              expression: "channel.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("chatbots.channels.orgs")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c("organizacion-component", {
                            attrs: {
                              custom_orgs: _vm.list_orgs,
                              show_all: false,
                            },
                            model: {
                              value: _vm.channel.domain,
                              callback: function ($$v) {
                                _vm.$set(_vm.channel, "domain", $$v)
                              },
                              expression: "channel.domain",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("chatbots.channels.description"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              filled: _vm.view,
                              dense: "",
                              outlined: "",
                              disabled: _vm.view,
                              rules: _vm.rules.description,
                              rows: 2,
                              hint: "(Opcional)",
                              "persistent-hint": "",
                            },
                            model: {
                              value: _vm.channel.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.channel, "description", $$v)
                              },
                              expression: "channel.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("chatbots.channels.type")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              items: _vm.types,
                              outlined: "",
                              dense: "",
                              filled: _vm.view,
                              readonly: _vm.view,
                            },
                            model: {
                              value: _vm.channel.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.channel, "type", $$v)
                              },
                              expression: "channel.type",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("chatbots.channels.shared")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSwitch, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                            },
                            model: {
                              value: _vm.channel.shared,
                              callback: function ($$v) {
                                _vm.$set(_vm.channel, "shared", $$v)
                              },
                              expression: "channel.shared",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.channel.type === "PLAYGROUND"
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("chatbots.channels.url"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "10" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  filled: _vm.view,
                                  disabled: _vm.view,
                                  rules: _vm.rules.url,
                                },
                                model: {
                                  value: _vm.channel.url,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.channel, "url", $$v)
                                  },
                                  expression: "channel.url",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.channel.type === "SUPPLIER"
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbots.channels.connection_id")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  filled: _vm.view,
                                  disabled: _vm.view,
                                  rules: _vm.rules.url,
                                },
                                model: {
                                  value: _vm.channel.account_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.channel, "account_id", $$v)
                                  },
                                  expression: "channel.account_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.channel.type === "WHATSAPP" ||
                  _vm.channel.type === "AZURE_BOT"
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbots.channels.account_id")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  filled: _vm.view,
                                  disabled: _vm.view,
                                  rules: _vm.rules.url,
                                },
                                model: {
                                  value: _vm.channel.account_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.channel, "account_id", $$v)
                                  },
                                  expression: "channel.account_id",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbots.channels.credentials")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  filled: _vm.view,
                                  disabled: _vm.view,
                                  rules: _vm.rules.url,
                                },
                                model: {
                                  value: _vm.channel.credentials,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.channel, "credentials", $$v)
                                  },
                                  expression: "channel.credentials",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }